export const toolNameByTaskName = {
  'babel': 'babel',
  'tsc': 'babel',
  'retire': 'retire',
  'mocha': 'mocha',
  'nsp': 'nsp',
  'check-dependencies': 'check-dependencies',
  'checkDependencies': 'check-dependencies',
  'check-file-names': 'check-file-names',
  'checkFileNames': 'check-file-names',
  'conventional-changelog': 'conventional-changelog',
  'conventionalChangelog': 'conventional-changelog',
  'jsdoc': 'jsdoc',
  'tslint': 'tslint',
  'eslint': 'eslint',
  'webpack': 'webpack'
};
